export default "__VITE_ASSET__D7t5V4j4__"